import * as actionTypes from '../actions/actionTypes';
import {CASEBODY_TAB_NAMES} from '../../../constants';

const intiData = {
  customerDetailsTab: {
    disabled: false,
    isComplete: false
  },
  productRequestsTab: {
    disabled: false,
    isComplete: false
  },
  documentationTab: {
    disabled: true,
    isComplete: false
  },
  activationTab: {
    disabled: true,
    isComplete: false
  },
  activeTabId: 0
};

export default function caseBodytTabsReducer(state = intiData, action) {
  switch(action.type){
    case actionTypes.SET_CURRENT_ACTIVE_TAB: {
      const {activeTabId} = action;
      return {...state, activeTabId};
    }
    case actionTypes.SET_TABS_STATUS: {
      const {tabName, isComplete} = action;
      return {...state, [tabName]: {disabled: state[tabName]["disabled"], isComplete}};
    }
    case actionTypes.SET_TABS_STATUSES: {
      const {tabStatuses} = action;
      let _newState = {...state};
      tabStatuses.forEach((tabStatus, index) => {
        if(tabStatus === "complete") {
          _newState[CASEBODY_TAB_NAMES[index]].isComplete = true;
        }else {
          _newState[CASEBODY_TAB_NAMES[index]].isComplete = false;
        }
      });
      return _newState;
    }
    case actionTypes.ENABLE_TAB: {
      const {tabName} = action;
      return {...state, [tabName]: { disabled: false, isComplete: state[tabName]["isComplete"] }};
    }
    case actionTypes.ENABLE_TABS: {
      const {tabNames} = action;
      let _newTabsState = {...state};
      tabNames.forEach(tabName => {
        _newTabsState[tabName].disabled = false
      });
      return _newTabsState;
    }
    case actionTypes.DISABLE_TAB: {
      const {tabName} = action;
      return {...state, [tabName]: { disabled: true, isComplete: state[tabName]["isComplete"] }};
    }
    case actionTypes.DISABLE_TABS: {
      const {tabNames} = action;
      let _newTabsState = {...state};
      tabNames.forEach(tabName => {
        _newTabsState[tabName].disabled = true
      });
      return _newTabsState;
    }
    default: {
      return state;
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/CaseBody/reducers/caseBodytTabsReducer.js